export default __webpack_public_path__ + "step-success.png";